import { render, staticRenderFns } from "./trainingAssessment.vue?vue&type=template&id=0f157ebd&scoped=true"
import script from "./trainingAssessment.vue?vue&type=script&lang=js"
export * from "./trainingAssessment.vue?vue&type=script&lang=js"
import style0 from "./trainingAssessment.vue?vue&type=style&index=0&id=0f157ebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f157ebd",
  null
  
)

export default component.exports